/**
 * Safe same-origin HashRouter return paths after login (push click recovery).
 * Invitation flows stay special-cased and must win over return state.
 */

export function isSafeLoginReturnPath(hashPath) {
  return typeof hashPath === 'string' && hashPath.startsWith('/') && !hashPath.startsWith('//');
}

/**
 * @param {{ pathname?: string, search?: string } | null | undefined} location
 */
export function buildLoginReturnFromLocation(location) {
  const pathname = typeof location?.pathname === 'string' ? location.pathname : '';
  const search = typeof location?.search === 'string' ? location.search : '';
  if (!pathname.startsWith('/') || pathname.startsWith('//')) return null;
  return { pathname, search };
}

/**
 * @param {{
 *   invitationInUrl?: string | null,
 *   locationSearch?: string,
 *   from?: { pathname?: string, search?: string } | null,
 * }} args
 */
export function resolvePostLoginNavigateTarget({
  invitationInUrl = null,
  locationSearch = '',
  from = null,
} = {}) {
  const search = typeof locationSearch === 'string' ? locationSearch : '';
  if (invitationInUrl) return `/signup${search}`;
  if (from && isSafeLoginReturnPath(`${from.pathname || ''}`)) {
    const path = `${from.pathname || ''}${typeof from.search === 'string' ? from.search : ''}`;
    if (isSafeLoginReturnPath(path)) return path;
  }
  // Preserve prior ordinary login behavior: home + current login search (if any).
  return search ? `/${search}` : '/';
}
